import Vue from 'vue'
import Util from '@/common/Util';
import Task from '@/common/Task';
import * as DateTime from '@/common/DateTime';

//the StoreGraph stores the task and edge data; cytoscape only records their uuid and display info
export const storeUI = {
  state: {
    name: 'storeUI',
    title: 'Tasker',
    tasks: [],//task [name, number, uuid] are unique
    edges: [] //{uuid: Util.uuidv4(), source: tp.uuid, target: tc.uuid};
  },
  getters: { //store getters CANNOT have arguments, logic shifted into Graph
    getWindowTitle(state){
      return state.title;
    }
  },
  mutations: { //setters CANNOT return values
    setWindowTitle(state, title){
      Vue.$log.info('window title set to ' + title);
      state.title = title;
    }
  },
  actions: {
  }
}
